import { render, staticRenderFns } from "./HtemlView.vue?vue&type=template&id=b3c31c02&scoped=true"
import script from "./HtemlView.vue?vue&type=script&lang=js"
export * from "./HtemlView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c31c02",
  null
  
)

export default component.exports